
import { IGeneralSettingsRepository } from '../interfaces';

export const LEADERBOARD_FAKE_NAMES = 'LEADERBOARD_FAKE_NAMES';

export class DbGeneralSettingsRepository implements IGeneralSettingsRepository {
    constructor(private db: any, private logger: any) { }

    public async getAllLeaderboardFakeNames(): Promise<string[]> {
        try {
            const docs = await this.db.get(LEADERBOARD_FAKE_NAMES);
            this.logger.info(`loading fake names`);
            if (docs == null || docs.firstnames == null || docs.firstnames.length < 1) {
                throw new Error('Expected to get firstnames in doc LEADERBOARD_FAKE_NAMES in general settings db');
            }
            if (docs.firstnames.length < 10) {
              throw new Error('Expected at least 1000 firstnames in doc LEADERBOARD_FAKE_NAMES in general settings db');
            }
            const firstNames: string[] = docs.firstnames;
            this.logger.info(`loaded ${firstNames.length} fake names`);
            return firstNames;
          } catch (ex) {
            this.logger.log('Error', 'Could not load fake names', ex);
            return [];
          }
    }
}
